<template>
  <div class="mains">

    <!--    <div class="tiyouimg">-->
    <!--      <img src="../assets/img/detail/detail.png" alt="">-->
    <!--    </div>-->

    <!--    <div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;flex-direction: column">-->
    <!--      <div style="width: 70%;display: flex;height: 100px;align-items: center;border-bottom: 1px solid #eee;justify-content: flex-end"-->
    <!--           v-for="(item,i) in dongtailist "-->
    <!--           @click="tonewpage(item.url)">-->
    <!--          <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;width: 80px;height: 80px">-->
    <!--            <div style="font-size: 3rem;font-weight: bold;color: #828A91;">{{getDay(item.topTime)}}</div>-->
    <!--            <div style="color: #828A91;">{{ getYearM(item.topTime) }}</div>-->
    <!--          </div>-->

    <!--          <div style="height: 80px;width: 1px;background-color:#eee;margin: 0 10px"></div>-->

    <!--          <div style="width: 80%;padding-left: 20px;cursor: pointer;font-weight: bold;font-size: 24px" >{{ item.content }}</div>-->
    <!--          <div class="more" >-->
    <!--            More>>-->
    <!--          </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div style="width: 100%;height: 100%;justify-content: center;display: flex;flex-direction: column;align-items: center;margin-top: 20px">
      <!--      <h2>-公司动态-</h2>-->
      <div style="margin-bottom: 20px;" class="page">
        <h2 style="font-weight: bold; font-size: 40px">公司动态</h2>
        <h6>THE COMPANY DYNAMIC</h6>
      </div>
      <!--      <div style="width: 70%;display: flex;margin-top: 10px;justify-content: space-between;margin-bottom: 20px;">-->
      <!--        <div style="display: flex;align-items: center;flex-direction: column;width: 45%">-->
      <!--            <div class="hoverimgdiv" style="width: 80%;height: auto;max-height: 100%;display: flex;align-items: center;flex-direction: column;-->
      <!--            ">-->
      <!--              <div style="width: 80%;height: 120px;overflow: hidden;margin-top: 40px">-->
      <!--                <img class="hoverimg"   src="../assets/img/tp.jpg" alt="">-->
      <!--              </div>-->
      <!--                <div @click="tonewpage(firstList[0].url)" style="width: 80%;height: 10px;margin-top: 15px;display: flex;justify-content: space-between;margin-bottom: 20px;flex-wrap: wrap">-->
      <!--                  <div style="font-weight: bold;font-size: 18px;" class="content">{{ firstList[0].content }}</div>-->
      <!--                  <div>{{ getDate(firstList[0].topTime) }}</div>-->
      <!--                </div>-->
      <!--            </div>-->
      <!--        </div>-->
      <!--        <div style="width:52%;">-->
      <!--          <div style="width: 100%;height: auto">-->
      <!--            <div v-for="(item,i) in threeList" @click="tonewpage(item.url)" class="hoversec"  style="height: 80px;width: 100%;display: flex;justify-content: space-between;align-items: center">-->
      <!--              <div class="content" style="font-weight: bold;font-size: 18px;width: 60%">{{ item.content }}</div>-->
      <!--              <div style="color: #999;">{{getDate(item.topTime)}}</div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <div v-show="manping" style="height: auto;width: 70%;display: flex;margin-top: 20px;justify-content: space-between;margin-bottom: 20px;flex-direction: column">
        <div class="hoversec" v-for="(item,i) in overfourList" @click="tonewpage(item.url)" style="height: 50px;width: 100%;display: flex;justify-content: space-between;align-items: center">
          <div class="content" style=";font-size: 18px">>>{{ item.content }}</div>
          <div style="color: #999;">{{ getDate(item.topTime) }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Axios from "axios";

export default {
  name: "Detail",
  data() {
    return {
      dongtailist:[],
      manping:false,
      firstList:[],
      threeList:[],
      overfourList:[],
    }
  },
  created() {
    this.getDonginfo()
  },
  methods:{
    //获取ri
    getDay(val){
      return new Date(val).getDate()
    },
    //获取日月
    getYearM(val){
      return new Date(val).getFullYear() + "-" +  (new Date(val).getMonth() + 1)
    },

    //获取年月日
    getDate(val){
      return new Date(val).getFullYear() + "-" +  (new Date(val).getMonth() + 1) + "-" + new Date(val).getDate() ;
    },

    getDonginfo(){
      let api = "http://123.57.205.53:8090/info_college/xqcompanyinfo/queryCompanyInfoList"
      Axios.post(api,{
        "content":"",
        "topStatus":"",
        "userRealName":"",
        "page":1,
        "limit":""
      }).then((response)=>{
        this.dongtailist = response.data.data.list;//response.data.result;

        let newlistlength = this.dongtailist.length
        if(this.dongtailist.length < 0 ){
          let a = {
            "content":"暂无",
            "url" : "#",
            "topTime" : this.getNowFormatDate()
          }
          this.firstList.push(
              a
          )
        }
        // else if(this.dongtailist.length>1 && this.dongtailist.length < 5){
        //   this.firstList = this.dongtailist.slice(0,1)
        //   this.threeList = this.dongtailist.slice(1)
        // }
        if(this.dongtailist.length > 0){
          this.manping = true;
          // this.firstList = this.dongtailist.slice(0,1);
          // this.threeList = this.dongtailist.slice(1,4);
          this.overfourList = this.dongtailist.splice( 0)

        }
      }).catch((error)=>{
        console.log(error);
      })
    },
    tonewpage(url){
      // window.location.href =
      window.open('https://' + url)
    },
  }
}
import "../assets/css/detail.css"
</script>

<style lang="scss" scoped>
.mains {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: white;
  flex-direction: column;
  display: flex;

  .tiyouimg {
    width: 100%;
  }
}
.more{
  background-color:#1F8CCE;
  width: 80px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.more:hover{
  background-color: #444;
  cursor: pointer;

}
.hoverimg:hover{
  transition: .5s transform;
  transform: scale(1.15);

}
.hoverimg{
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;

  transition-property: all;
  transition-duration: 0.36s;
  transition-timing-function: ease;
  transition-delay: 0s;
}

.hoverimgdiv{
  .content{
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
  }
}


.hoverimgdiv:hover{
  box-shadow: 0 0 10px hsla(0,0%,0%,.15); border-radius: 8px;
  transition-property: all;
  transition-duration: 0.36s;
  transition-timing-function: ease;
  transition-delay: 0s;
  .content{
    box-shadow:none;
    color: #ffbc00;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
  }
}
.hoversec{
  padding: 0 30px;
  cursor: pointer;
  .content{
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
  }
}

.hoversec:hover{
  box-shadow: 0 0 10px hsla(0,0%,0%,.15); border-radius: 8px;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-delay: 0s;
  .content{
    box-shadow:none;
    color: #1F8CCE;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
  }
}
</style>
